import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

interface DadMoment {
  title: string;
  text: string;
  image?: string;
}

const dadMoments: DadMoment[] = [
    { 
        title: "Day 0", 
        text: "Finally meeting you (and dressing up in scrubs!) was the best experience 🩺",
        image: "/photos/newborn.jpg"
        },
  { 
    title: "Cuddle Champion", 
    text: "You always give the best cuddles 💙",
    image: "/photos/cuddles.jpg"
  },
  { 
    title: "Chillaxing", 
    text: "Taking a break and relaxing with you is always fun 😎",
    image: "/photos/relaxing.jpg" 
  },
  { 
    title: "Gamers gaming", 
    text: "And so is playing video games with you! 🎮",
    image: "/photos/gaming.jpg" 
  },
  { 
    title: "Silly time", 
    text: "We're so goofy together 😄",
    image: "/photos/goofy.jpg"
  },
  { 
    title: "Mama's handsome boys", 
    text: "And we definitely clean up nice! 🔥",
    image: "/photos/minime.jpg"
  },
  { 
    title: "Special memories", 
    text: "I'm so glad we finally got to spend our first Eid together! 🐐",
    image: "/photos/eid.jpg"
  },
  { 
    title: "Many adventures!", 
    text: "And go on adventures from the sky ✈",
    image: "/photos/adventures.jpg"
  },
  { 
    title: "Under water", 
    text: "To the sea we go! 🌊",
    image: "/photos/swimming.jpg"
  },
  { 
    title: "Happy Father's Day!", 
    text: "Thank you for being the best Baba! 🎉",
    image: "/photos/baby.jpg"
  }
];

const DadMoments: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextPage = () => {
    setCurrentIndex((prev) => (prev + 1) % dadMoments.length);
  };

  const prevPage = () => {
    setCurrentIndex((prev) => (prev - 1 + dadMoments.length) % dadMoments.length);
  };

  return (
    <div className="min-h-screen bg-storybook-bg flex items-center justify-center p-4">
      <div className="relative w-full max-w-2xl">
        {/* Navigation Buttons */}
        <button
          onClick={prevPage}
          className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-12 z-10 bg-white rounded-full p-3 shadow-lg hover:bg-gray-100 transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <button
          onClick={nextPage}
          className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-12 z-10 bg-white rounded-full p-3 shadow-lg hover:bg-gray-100 transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>

        {/* Storybook Card */}
          <motion.div
            key={currentIndex}
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={{ duration: 0.5 }}
            className="bg-storybook-card rounded-2xl p-8 shadow-xl"
          >
            <div className="text-center">
              <h2 className="text-3xl font-comic font-bold text-gray-800 mb-4">
                {dadMoments[currentIndex].title}
              </h2>
              <div className="mb-6 min-h-[200px] flex items-center justify-center">
                {dadMoments[currentIndex].image ? (
                  <img 
                    src={dadMoments[currentIndex].image} 
                    alt={`${dadMoments[currentIndex].title} moment`}
                    className="mx-auto rounded-lg shadow-md max-h-64 object-cover"
                  />
                ) : (
                  <div className="w-full h-48 bg-gray-100 rounded-lg flex items-center justify-center">
                    <span className="text-gray-400">Add a photo here 📸</span>
                  </div>
                )}
              </div>
              <p className="text-xl font-comic text-gray-600">
                {dadMoments[currentIndex].text}
              </p>
            </div>
          </motion.div>

        {/* Page Indicator */}
        <div className="flex justify-center mt-4 gap-2">
          {dadMoments.map((_, index) => (
            <div
              key={index}
              className={`w-2 h-2 rounded-full transition-colors ${
                index === currentIndex ? 'bg-blue-500' : 'bg-gray-300'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DadMoments; 